export default value => (value ? 'Slettet' : 'Aktivt');
